import { useEffect, useState } from "react";
import { FragmentsManager } from "@thatopen/components";
import useViewerContext from "@/services/context/viewer/instance/use-viewer-context.ts";
import { resolveViewerObjectIds } from "@/utils/viewer-object-identity.ts";
import { AssociatedObjectAndTypo } from "../models/associated-object-and-typo.ts";

const useShellGeometries = (shells: AssociatedObjectAndTypo[]): AssociatedObjectAndTypo[] => {
    const { viewer, isLoading } = useViewerContext();
    const [resolvedShells, setResolvedShells] = useState<AssociatedObjectAndTypo[]>([]);

    useEffect(() => {
        if (isLoading || !viewer) {
            return undefined;
        }

        let cancelled = false;

        const resolveShells = async () => {
            const fragments = viewer.getComponents().get(FragmentsManager);
            const ids = shells.flatMap(shell => shell._3D ?? []);
            const aliases = await resolveViewerObjectIds(ids, fragments.list.values());
            const geometries = shells.flatMap(shell => {
                const viewerIds = aliases.get(shell._3D ?? '') ?? [];

                return viewerIds.map(id => ({ ...shell, _3D: id }));
            });

            if (!cancelled) {
                setResolvedShells(geometries);
            }
        };

        resolveShells().catch(error => {
            if (!cancelled) {
                console.error("Erreur lors de la résolution des géométries des coques", error);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [isLoading, shells, viewer]);

    return resolvedShells;
};

export default useShellGeometries;
